import { useState, useEffect } from "react";
import Popup from "./Popup";
import { FormInput } from "./FormInput";
import { FormSelect } from "./FormSelect";

export default function RenewLicenseModal({
  isOpen,
  onClose,
  onSubmit,
  license = null,
}) {
  const [formData, setFormData] = useState({
    durationDays: 30,
    tier: "",
    purchaseAmount: "",
  });

  useEffect(() => {
    if (license) {
      setFormData({
        durationDays: 30,
        tier: license.tier || "",
        purchaseAmount: "",
      });
    }
  }, [license]);

  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit({
      ...formData,
      purchaseAmount: parseFloat(formData.purchaseAmount),
    });
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  if (!isOpen || !license) return null;

  return (
    <Popup
      popupTitle={`Renew License: ${license.licenseId}`}
      onClose={onClose}
      width="max-w-md"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Duration */}
        <FormInput
          label="Duration (Days)"
          type="number"
          required
          min={1}
          value={formData.durationDays}
          onChange={(e) =>
            handleInputChange("durationDays", parseInt(e.target.value))
          }
        />

        {/* Tier */}
        <FormSelect
          label="Tier"
          required
          value={formData.tier}
          onChange={(e) => handleInputChange("tier", e.target.value)}
          options={[
            { label: "Basic", value: "basic" },
            { label: "Whatsapp", value: "whatsapp" },
            { label: "AI Only", value: "ai_only" },
            { label: "AI and Whatsapp", value: "ai_and_whatsapp" },
          ]}
        />

        {/* Purchase Amount */}
        <FormInput
          label="Purchase Amount"
          type="number"
          step="0.01"
          required
          value={formData.purchaseAmount}
          onChange={(e) => handleInputChange("purchaseAmount", e.target.value)}
          placeholder="99.99"
        />

        {/* Actions */}
        <div className="flex gap-3 pt-4">
          <button
            type="submit"
            className="flex-1 px-4 py-2 bg-slate-900 text-white rounded-lg hover:bg-slate-800 font-medium transition-colors"
          >
            Renew License
          </button>
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-slate-200 rounded-lg text-slate-700 hover:bg-slate-50 font-medium transition-colors"
          >
            Cancel
          </button>
        </div>
      </form>
    </Popup>
  );
}
